import script from "./template_18.vue?vue&type=script&setup=true&lang=js"
export * from "./template_18.vue?vue&type=script&setup=true&lang=js"

import "./template_18.vue?vue&type=style&index=0&id=b55956d6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/logexpo/logexpo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b55956d6"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
